import { PrefillSurveyFieldsInfo } from '../../models/survey';
import { CheckoutState } from '../../state';
import {
    getEmailToPrefill,
    getFirstNameToPrefill,
    getLastNameToPrefill,
} from '../../utils/user';
import { getIsTransferredOrder } from '../order';
import { shouldManageUserSavedSurveyData } from '../order/typedOrderSelectors';
import {
    getIsCurrentPageDisplayingBasicInfoQuestions,
    getOriginalAnswersByAttendeeId,
} from '../survey';
import { getFirstAttendeeWithSurvey } from './pureSelectors';

export const getPrefillSurveyInfo = (
    state: CheckoutState,
): PrefillSurveyFieldsInfo => ({
    attendeeWithSurvey: getFirstAttendeeWithSurvey(state),
    emailToPrefill: getEmailToPrefill(state),
    firstNameToPrefill: getFirstNameToPrefill(state),
    isTransferredOrder: getIsTransferredOrder(state),
    lastNameToPrefill: getLastNameToPrefill(state),
    shouldManageUserSavedSurveyData: shouldManageUserSavedSurveyData(state),
    shouldPrefillFirstAttendeeBasicInfoQuestions:
        getIsCurrentPageDisplayingBasicInfoQuestions(state),
    surveyReponsesByAttendeeId: getOriginalAnswersByAttendeeId(state),
});
